export const trackPayButtonClick = (): void => {
  // @ts-ignore
  if (window.gtag) {
    // @ts-ignore
    window.gtag('event', 'pay_button_click', {
      event_category: 'Pay button',
      value: 1,
    });
  }
};
